<template>
  <v-container fluid class="pa-5 pb-16 elevation-1">
    <!-- HEADER -->
    <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
      <h1 class="text-h4 font-weight-bold d-flex align-center">
        <v-btn icon color="blue">
          <v-icon>mdi-robot</v-icon>
        </v-btn>
        {{ $t("modelitw") }}
      </h1>
    </v-sheet>
    <!-- CONTENIDO -->
    <v-card>
      <!-- FILTROS -->
      <v-card class="filters cool-card">
        <div class="filter-gorup">
          <label>{{ $t("buscar") }}</label>
          <v-text-field
            v-model.trim="search"
            :placeholder="$t('input_filtro')"
            variant="outlined"
            density="comfortable"
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
          />
        </div>

        <div class="filter-actions">
          <v-btn
            variant="elevated"
            color="primary"
            size="large"
            rounded="x1"
            @click="onCrear"
            v-if="createPermission"
          >
            {{ $t("nuevo_proyecto") }}
          </v-btn>
        </div>
      </v-card>

      <!-- sin proyectos -->
      <v-empty-state
        v-if="projects.length === 0"
        icon="mdi-folder-outline"
        :title="$t('no_proyectos')"
        :text="$t('no_proyectos_msg')"
      >
        <template #actions>
          <v-btn
            color="primary"
            rounded="lg"
            size="large"
            @click="onCrear"
            v-if="createPermission"
          >
            + {{ $t("nuevo_proyecto") }}
          </v-btn>
        </template>
      </v-empty-state>

      <!-- TABLA -->
      <template v-else>
        <!-- filtros -->
        <v-empty-state
          v-if="projects.length > 0 && filteredProjects.length === 0"
          icon="mdi-magnify"
          :title="$t('no_resultados')"
          :text="$t('no_resultados_msg')"
        >
          <template #actions>
            <v-btn
              variant="tonal"
              color="primary"
              rounded="lg"
              @click="clearFilters"
            >
              {{ $t("filtros") }}
            </v-btn>
          </template>
        </v-empty-state>
        <v-card
          v-else
          rounded="lg"
          variant="outlined"
          class="cool-card table-card"
        >
          <v-table class="pro-table" hover>
            <thead>
              <tr>
                <th class="col-proyecto">{{ $t("project") }}</th>
                <th class="col-estado">{{ $t("Estado") }}</th>
                <th class="col-estado">Unidad</th>
                <th class="col-qalead">{{ $t("QA_Lead") }}</th>
                <th class="col-tipo">{{ $t("Tipo_proyecto") }}</th>
                <th class="col-actual">{{ $t("actualizacion") }}</th>
                <th class="col-acciones text-center">{{ $t("Acciones") }}</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="p in pagedProjects" :key="p.idProyect">
                <td>
                  <div class="project-title">{{ p.nombre }}</div>
                  <div class="project-meta">
                    ID: {{ p.clave }} · {{ $t("cliente") }} {{ p.cliente }}
                  </div>
                </td>

                <td>
                  <span class="status" :class="statusClass(p.estado)">
                    <span class="dot"></span> {{ p.estado }}
                  </span>
                </td>
                <td>{{ p.cliente }}</td>
                <td>{{ p.qaLead }}</td>
                <td>{{ p.tipo }}</td>
                <td>{{ p.actualizacion }}</td>

                <td class="text-center">
                  <div class="actions actions--table">
                    <v-tooltip text="Editar" location="top">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          elevation="2"
                          class="action-btn"
                          :disabled="!editPermission"
                          @click="openEdit(p)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>

                    <v-tooltip text="IAModels" location="top">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          elevation="2"
                          class="action-btn"
                          @click="openIAModels(p)"
                        >
                          <v-icon>mdi-file-document-outline</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>

                    <v-tooltip text="Eliminar proyecto" location="top">
                      <template #activator="{ props }">
                        <v-btn
                          v-bind="props"
                          icon
                          elevation="2"
                          class="action-btn"
                          :disabled="!deletePermission"
                          @click="openDelete(p)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-table>
          <!-- FOOTER / PAGINACIÓN -->
          <v-divider class="my-4" />

          <div
            class="d-flex align-center justify-space-between flex-wrap ga-3 px-4 pb-4 table-footer"
          >
            <div class="d-flex align-center ga-2">
              <span class="text-caption text-medium-emphasis">
                {{ $t("paginacion") }}
              </span>

              <v-select
                v-model="itemsPerPage"
                :items="[5, 8, 10, 20]"
                density="compact"
                variant="outlined"
                hide-details
                class="items-select"
                style="max-width: 110px"
              />
            </div>

            <v-pagination
              v-model="page"
              :length="pageCount"
              density="comfortable"
              :total-visible="6"
            />
          </div>
        </v-card>
      </template>
    </v-card>
    <!-- MODAL: Crear Proyecto -->
    <NuevoProyecto v-model="crearDialog" mode="create" @save="onSaveProject" />

    <!-- MODAL EDITAR -->
    <NuevoProyecto
      v-model="editDialog"
      mode="edit"
      :project="selectedProject"
      :key="selectedProject?.idProyect || 'edit'"
      @save="onUpdateProject"
    />

    <!-- MODAL ELIMINAR -->
    <DeleteProyecto
      v-model="deleteDialog"
      :project="projectToDelete"
      @deleted="fetchProjects"
    />
  </v-container>
</template>
<script>
import "@/css/Global.css";
import NuevoProyecto from "./NuevoProyecto.vue";
import DeleteProyecto from "./DeleteProyecto.vue";
import { swal } from "@/utils/swal.js";
import { useProjectStore } from "@/stores/projectStore";
import {
  getUnitBussines,
  getProjectsForTeams,
  getProyectoDetail,
  getPermissionsProyects,
} from "@/api/proyectos.js";
export default {
  name: "GeneracionProyecto",
  components: { NuevoProyecto, DeleteProyecto },
  data() {
    return {
      crearDialog: false,
      search: "",
      idProyect: null,
      estado: "",
      page: 1,
      itemsPerPage: 5,
      deleteDialog: false,
      projectToDelete: null,
      editDialog: false,
      selectedProject: null,
      tipo: "",
      isNotAdm: false,
      projects: [],
      loadingProjects: false,
      unitMap: {},
      editPermission: false,
      createPermission: false,
      deletePermission: false,
    };
  },
  async mounted() {
    await this.fetchUnits();
    await this.fetchProjects();
    await this.permisosValidateProyects();
  },
  computed: {
    filteredProjects() {
      const q = (this.search || "").toLowerCase();

      return this.projects.filter((p) => {
        const matchesSearch =
          !q ||
          p.nombre.toLowerCase().includes(q) ||
          p.clave.toLowerCase().includes(q) ||
          p.qaLead.toLowerCase().includes(q) ||
          p.cliente.toLowerCase().includes(q) ||
          p.tipo.toLowerCase().includes(q) ||
          p.cliente.toLowerCase().includes(q) ||
          p.estado.toLowerCase().includes(q);

        const matchesEstado = !this.estado || p.estado === this.estado;
        const matchesTipo = !this.tipo || p.tipo === this.tipo;

        return matchesSearch && matchesEstado && matchesTipo;
      });
    },
    pageCount() {
      const total = this.filteredProjects.length;
      const per = Number(this.itemsPerPage) || 8;
      return Math.max(1, Math.ceil(total / per));
    },

    pagedProjects() {
      console.log("RRR", this.filteredProjects)
      const per = Number(this.itemsPerPage) || 8;
      const start = (this.page - 1) * per;
      return this.filteredProjects.slice(start, start + per);
    },
  },
  watch: {
    search() {
      this.page = 1;
    },
    estado() {
      this.page = 1;
    },
    tipo() {
      this.page = 1;
    },
    itemsPerPage() {
      this.page = 1;
    },
    projects() {
      this.page = 1;
    },
  },
  methods: {
    openDelete(p) {
      this.projectToDelete = p;
      this.deleteDialog = true;
    },
    openIAModels(p) {
      const useStore = useProjectStore();
      useStore.setProject(p);
      this.$router.push({
        name: "IAModel",
        query: {
          projectName: p.idProyect,
        },
      });
    },
    confirmDelete(project) {
      this.projects = this.projects.filter(
        (p) => p.idProyect !== project.idProyect,
      );
    },
    async openEdit(p) {
      const pk = p.clave || p.id;

      this.editDialog = true;
      this.selectedProject = p.raw ? JSON.parse(JSON.stringify(p.raw)) : p;

      try {
        const detail = await getProyectoDetail(pk);
        console.log(detail);
        if (detail) this.selectedProject = detail;
      } catch {
        return;
      }
    },
    async onUpdateProject() {
      await this.fetchProjects();
    },
    statusClass(estado) {
      if (estado === "En curso") return "en-curso";
      if (estado === "Nuevo") return "nuevo";
      return "mantenimiento";
    },

    clearFilters() {
      this.search = "";
      this.estado = "";
      this.tipo = "";
      this.page = 1;
    },

    onExportar() {
      //console.log('Exportar', this.filteredProjects)
    },

    onCrear() {
      this.crearDialog = true;
    },

    async onSaveProject() {
      await this.fetchProjects();
    },
    async fetchUnits() {
      try {
        const data = await getUnitBussines();
        this.unitMap = Object.fromEntries(
          (data || []).map((u) => [u.id, u.nameUnitBussines]),
        );
      } catch (e) {
        console.error("Error unidades:", e);
        this.unitMap = {};
      }
    },
    mapProjectFromApi(p) {
      return {
        idProyect: p.idProyect,
        nombre: p.nameProyect ?? "",
        clave: p.idProyect ?? "",
        cliente: this.unitMap[p.UnitBussines] ?? "",
        estado: p.status ?? "Nuevo",
        qaLead: p.accountable ?? "",
        tipo: p.typeProject ?? p.typeProject ?? "",
        actualizacion: p.updatedAt ?? "Hoy",

        raw: p,
      };
    },
    async permisosValidateProyects() {
      try {
        const data = await getPermissionsProyects();
        this.editPermission = data.data.permisos.editar;
        this.createPermission = data.data.permisos.crear;
        this.deletePermission = data.data.permisos.eliminar;
      } catch (error) {
        if (error.response && error.response.status === 403) {
          return {
            error: error.response.data.detail || "No tienes permisos",
          };
        }

        throw error;
      }
    },

    async fetchProjects() {
      this.loadingProjects = true;
      this.isNotAdm = false;
      try {
        const data = await getProjectsForTeams({ chatgpt: false });
        this.projects = (data || []).map(this.mapProjectFromApi);
      } catch (e) {
        const status = e?.response?.status;
        if (status === 403) {
          this.isNotAdm = true;
         await swal({
            icon: "error",
            title: this.$t("swaltitulo"),
            text: this.$t("swaltext"),
            timer: 2500,

            showConfirmButton: false,
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          });
          this.projects = [];
          return;
        }
        this.projects = [];
      } finally {
        this.loadingProjects = false;
      }
    },
  },
};
</script>
